import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "xcell xname" }
const _hoisted_2 = {
  class: "xusericon",
  "data-size": "small"
}
const _hoisted_3 = { class: "xusericon-picture" }
const _hoisted_4 = { class: "xpage-openapps-box-name" }
const _hoisted_5 = ["title", "innerHTML"]
const _hoisted_6 = ["title"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "xcell xsearchtext" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "xcell xdate" }
const _hoisted_11 = {
  key: 0,
  style: {"color":"red"}
}

import useFunctions from "@/use/functions1";
import { useDebugDateKey } from "@/composables/useDebugDateKey";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoanResultCard',
  props: {
    application: {},
    pageName: {},
    layout: {}
  },
  emits: ["setSelectedApplication"],
  setup(__props: any, { emit: __emit }) {

const { decodeHTMLEncodedStr } = useFunctions();
const { showCreatedDate } = useDebugDateKey();

const props = __props;

const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "xrow",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('setSelectedApplication', __props.application))),
    to: `/${__props.pageName.toLowerCase()}/${__props.application.referenceId}`
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(decodeHTMLEncodedStr)(__props.application.initials) || ""), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", {
            title: _unref(decodeHTMLEncodedStr)(__props.application.name) || 'No Name',
            innerHTML: _unref(decodeHTMLEncodedStr)(__props.application.name) || 'No Name'
          }, null, 8, _hoisted_5),
          _createElementVNode("h5", {
            title: __props.application.lenderName || __props.application.defaultLenderName
          }, _toDisplayString(__props.application.lenderName || __props.application.defaultLenderName), 9, _hoisted_6),
          _createElementVNode("h6", {
            innerHTML: __props.application.searchNotification
          }, null, 8, _hoisted_7)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (__props.application.nameCoApplicant)
          ? (_openBlock(), _createElementBlock("h6", {
              key: 0,
              innerHTML: __props.application.nameCoApplicant
            }, null, 8, _hoisted_9))
          : _createCommentVNode("", true)
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "xcell xprogress" }, [
        _createElementVNode("div", { class: "xpage-openapps-box-bar" }, [
          _createElementVNode("div", { class: "xpage-openapps-box-bar-inner width-100" })
        ]),
        _createElementVNode("h4", null, "Progress")
      ], -1)),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("h3", null, _toDisplayString(__props.application.createdAtFormatted), 1),
        (_unref(showCreatedDate))
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(__props.application.createdAtUtc), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})